import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import sw from "../../locales/sw.json";
import nor from "../../locales/nor.json";
import da from "../../locales/da.json";
import fin from "../../locales/fin.json";
import ru from "../../locales/ru.json";
import en from "../../locales/en.json";
import gr from "../../locales/gr.json";
import { ModelStorage } from './modelStorage';

const lang = ModelStorage.getItem("i18nextLng") || "sw";

i18n.use(LanguageDetector).init({
  lng: lang,
  // we init with resources
  resources: {
    en: en,
    sw: sw,
    nor: nor,
    da: da,
    fin: fin,
    ru: ru,
    gr: gr
  },
  fallbackLng: "sw",
  debug: false,

  // // have a common namespace used around the full app
  // ns: ["translations"],
  // defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;
